import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';

import api from '../../../api/axios';
import { IApiState } from '../../../types/api';
import { RootState } from '../..';

interface IGetBillerItems {
  id?: string;
  name: string;
  amount?: number;
  description?: string;
  isFixedPrice?: boolean;
}

export interface IGetBillers {
  id?: string;
  name?: string;
  description?: string;
  imageUrl?: string;
  doLookUp?: boolean;
  currentProviderBillerItems?: IGetBillerItems[];
}

export interface IBillersResponse {
  status?: boolean;
  message?: string;
  data?: [
    {
      id?: string;
      name?: string;
      description?: string;
      isActive?: boolean;
      billers?: IGetBillers[];
    }
  ];
}

const initialState: IApiState<IBillersResponse['data']> = {
  value: null,
  status: 'idle',
  error: '',
};

export const getBillersCategoriesAsync = createAsyncThunk(
  'billersCategories/get',
  async (_, { rejectWithValue, getState, dispatch }) => {
    try {
      const state = getState() as RootState;

      const accessToken = state.auth.value?.data?.token?.accessToken;
      const businessId = localStorage.getItem('businessId');

      const config = {
        headers: {
          Authorization: `BearerToken ${accessToken}`,
          'X-Business-Id': businessId,
        },
      };

      const { data } = await api.get('billers/categories/all', config);

      return data;
    } catch (err) {
      const error = err as AxiosError<IBillersResponse>;

      return rejectWithValue(error.response?.data);
    }
  }
);

export const billersCategoriesFetch = createSlice({
  name: 'billersCategories/fetch',
  initialState,
  reducers: {
    resetBillersCategories: (state) => {
      state.value = null;
      state.status = 'idle';
      state.error = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getBillersCategoriesAsync.pending, (state) => {
        state.status = 'loading';
        state.error = '';
      })
      .addCase(getBillersCategoriesAsync.fulfilled, (state, action) => {
        state.status = 'success';
        const payload = action.payload as IBillersResponse;
        state.value = payload?.data || null;
      })
      .addCase(getBillersCategoriesAsync.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  },
});

export const { resetBillersCategories } = billersCategoriesFetch.actions;

export default billersCategoriesFetch.reducer;
